"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var THEME_BASE_1 = require("../../THEME_BASE");
var utils_1 = require("../../utils");
var tableColors = function (colorScheme, completeVariant, global, colors) {
    if (![THEME_BASE_1.COLOR_SCHEME_DARK, THEME_BASE_1.COLOR_SCHEME_LIGHT].includes(colorScheme)) {
        throw new Error("Requires \"".concat(THEME_BASE_1.COLOR_SCHEME_DARK, "\" or \"").concat(THEME_BASE_1.COLOR_SCHEME_LIGHT, "\" color scheme option."));
    }
    return {
        head: {
            background: colorScheme === THEME_BASE_1.COLOR_SCHEME_LIGHT ? (0, utils_1.opacify)(colors.gray[1], 0.18) : colors.gray[5],
        },
        row: {
            background: 'transparent',
            backgroundAlt: colorScheme === THEME_BASE_1.COLOR_SCHEME_LIGHT ? (0, utils_1.opacify)(colors.gray[1], 0.2) : (0, utils_1.opacify)(colors.gray[1], 0.08),
            backgroundHover: (0, utils_1.opacify)(colors.gray[2], 0.2),
            border: colorScheme === THEME_BASE_1.COLOR_SCHEME_LIGHT ? (0, utils_1.opacify)(colors.gray[1], 0.75) : (0, utils_1.opacify)(colors.gray[1], 0.20),
        },
        variant: {
            danger: completeVariant.light.danger,
            active: (0, utils_1.opacify)(colors.gray[2], 0.2),
            info: completeVariant.light.info,
            primary: completeVariant.light.primary,
            success: completeVariant.light.success,
            warning: completeVariant.light.warning,
        },
        variantHover: {
            danger: completeVariant.lighter.danger,
            active: (0, utils_1.opacify)(colors.gray[2], 0.2),
            info: completeVariant.lighter.info,
            primary: completeVariant.lighter.primary,
            success: completeVariant.lighter.success,
            warning: completeVariant.lighter.warning,
        },
    };
};
exports.default = tableColors;
